<template>
  <div class="page">
    <navigation>三方平台消费账单</navigation>
    <div class="main-container">
      <div class="title">
        <div class="title-text">支付计划</div>
        <div class="title-desc">(当前金额为计划提交金额，请以最终实际扣款金额为准)</div>
      </div>
     
      <div class="order-list" v-for="billNo in rightsNoList" :key="billNo">
        <div class="orderNo" @click="$router.push(`/repayment/detail-expense?repayBillNo=${billNo}&from=true`)">消费账单 {{rightsTypeMap[billNo] | productType}} ></div>
        <div class="order-item" v-for="item in rightsListMap[billNo]" :key="item.term + billNo">
          <div class="flex-item">
            <div class="ui-select" :class="{ selected: isSelected(item) }" @click="changeSelect(item)"></div>
            <div class="innerItem">
              <span>待支付金额 (元)</span>
              <p>{{ item.realPaidAmt | currency }}</p>
            </div>
          </div>
          <div class="innerItem" style="text-align: right;">
            <span>{{ item.term }}/{{ item.totalTerms }}期</span>
            <p :class="{ danger: item.termStatus === 'O' }"> {{ item.termStatus === "O" ? "已超期" : "待支付" }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="control-container">
      <template>
        <div class="flex-item">
          <div class="ui-select" :class="{ selected: isAllSelect }" @click="selectAll"></div>
          <span>全选</span>
          <p>共 {{ selectedList.length }} 笔 </p>
        </div>

        <nd-button class="next-btn" @click="confirm">确认</nd-button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      rightsList: [],
      rightsListMap: {},
      rightsNoList: [],
      selectedList: [],
      rightsTypeMap: {}
    }
  },
  computed: {
    isAllSelect () {
      return (this.rightsList?.length === this.selectedList?.length)
    }
  },
  filters: {
    productType (value) {
      const map = {
        'GPVIP': '大权益PRO',
        'GVIP': '大权益PRO'
      }
      return map[value] || value
    }
  },
  mounted () {
    this.info()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('order', ['getRepayBatchListX']),
    fillZero (num) {
      return num < 10 ? '0' + num : num
    },
    confirm () {
      sessionStorage.setItem('repayExpenseSelect', JSON.stringify(this.selectedList))
      this.$router.go(-1)
    },
    async info () {
      const { success, data } = await this.getRepayBatchListX()
      if (success) {
        const { rightsList } = data
        const storeRightSelected = JSON.parse(sessionStorage.getItem('repayExpenseSelect') || '[]')
        if (storeRightSelected?.length) {
          this.selectedList = storeRightSelected
        }
        this.rightsList = rightsList
        this.rightsNoList = Array.from(
          new Set(rightsList.map((item) => item.billNo))
        )

        rightsList.forEach((item) => {
          const { billNo } = item
          if (!this.rightsListMap[billNo]) {
            this.rightsListMap[billNo] = []
            this.rightsTypeMap[billNo] = item.productCode
          }
          this.rightsListMap[billNo].push(item)
        })
      }
    },
    selectAll () {
      // 1. 判断当前是否有选中项
      if (this.selectedList.length) {
        this.selectedList = []
        this.RightSelected = false
        return
      }

      this.rightsNoList.forEach((billNo) => {
        this.rightsListMap[billNo].forEach((item) => {
          this.selectedList.push(item)
        })
      })
    },
    changeSelect (item) {
      const { billNo, term, billStatus } = item
      const firstItem = this.rightsListMap[billNo][0]
      const index = this.rightsListMap[billNo].findIndex(
        (item) => item.term === term
      )
      const selectedItem = this.selectedList.find(
        (item) => item.billNo === billNo && item.term === term
      )

      // 1. 判断已选择列表里面是否已经有当前选项
      if (selectedItem) {
        // 取消逻辑 判断是否有跳期
        // 判断当前期的前面所有期供是否都已经取消
        const thisBillListTerm = this.rightsListMap[billNo].map(i => i.term).filter(i => i > term) || []
        if (thisBillListTerm?.length) {
          const selectedListTerm = this.selectedList.some(i => {
            return i.billNo === billNo && thisBillListTerm.includes(i.term)
          })
          if (selectedListTerm) {
            this.$message('请顺次取消还款期数')
            return
          }
        }

        this.selectedList = this.selectedList.filter(
          (item) => item.billNo !== billNo || item.term !== term
        )
      } else {
        // 2. 如果没有，判断当前期供是否是第一期
       
        if (firstItem.term === term) {
          this.selectedList.push(item)
        } else {
          // 判断当前期的上一期是否已经加入进去
          const preTerm = this.rightsListMap[billNo][index - 1]
          if (preTerm) {
            const _selectedList = this.selectedList.filter(
              (item) => item.billNo === billNo && item.term === preTerm.term
            ) || []
            const selectedPreItem = _selectedList.find((item) => item.term === preTerm.term)
            if (!selectedPreItem) {
              this.$message('请顺次选择还款期数')
              // 判断当前订单是否逾期 如果逾期那么勾选当前订单的所有期供
              if (billStatus === 'O') {
                this.selectedList = this.selectedList.filter(item => item.billNo !== billNo)
                this.rightsListMap[billNo].forEach(item => {
                  this.selectedList.push(item)
                })
              }
              return
            }
          }

          this.selectedList.push(item)
        }
      }
    },
    isSelected (item) {
      const { billNo, term } = item
      const selectedItem = this.selectedList.find(
        (item) => item.billNo === billNo && item.term === term
      )
      return !!selectedItem
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: #fafafa;
  position: relative;

  .control-container {
    background: #fff;
    width: 10rem;
    height: 180px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;

    .flex-item {
      display: flex;
      align-items: center;
      gap: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #333333;
      font-weight: 500;

      span {
        font-size: 28px;
      }

      p {
        font-family: DIN, DIN;
        font-weight: normal;
      }

    }



    .next-btn {
      width: 320px;
      height: 94px;
      line-height: 94px;
      margin-right: -10px;
    }

    .pending-btn {
      width: 100%;
      height: 94px;
      line-height: 94px;
      margin: 0 30px;
    }
  }

  .ui-select {
    width: 32px;
    height: 32px;
    background: url('./images/circle_01@2x.png') no-repeat center;
    background-size: 100% 100%;

    &.selected {
      background-image: url('./images/circle_02@2x.png');
    }
  }

  .main-container {
    width: 750px;
    padding: 0 30px;
    padding-bottom: 200px;
    min-height: calc(100vh - 200px);
    background: url(./images/bg_sanfang.png) no-repeat top left;
    background-size: 100% auto;

    .order-list {
      background: #fff;
      border-radius: 20px;
      margin-top: 20px;

      .orderNo {
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #999999;
        padding-left: 20px;
        border-bottom: 1px solid #eee;
      }

      .danger {
        color: #FB4A46
      }

      .order-item {
        .flex-item {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        display: flex;
        align-items: center;
        justify-content: space-between;
        padding:30px 20px;
        font-family: PingFangSC,
        PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #333333;

        span {
          font-size: 28px;
        }

        p.amount {
          font-family: DIN, DIN;
          font-weight: 500;
          font-size: 34px;
          color: #333333;
        }

      }
    }
  }

  .title {
    padding-top: 60px;
    color: #fff;

    .title-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
    }

    .title-desc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      margin-top: 15px;
    }
  }
}
</style>